module.exports = __webpack_public_path__ + "static/media/ratting-icon.1bc456c2.svg";